/**
 * @author       esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  getAutocompleteResultIcon.ts
 */

import { Image as ChakraImage } from '@chakra-ui/react'
import type { AutocompleteResult } from '@zcode/bizos'
import React from 'react'
import {
  AUTOCOMPLETE_ADDRESS,
  AUTOCOMPLETE_BUILDING,
  AUTOCOMPLETE_CITY,
  AUTOCOMPLETE_NEIGHBORHOOD,
  AUTOCOMPLETE_POSTCODE,
} from '../constants'
import MultipleBuildings from '../icons/MultipleBuildings.svg'
import ZipcodeIcon from '../icons/Zipcode.svg'

export function getAutocompleteResultIcon(type: AutocompleteResult['type']) {
  switch (type) {
    case AUTOCOMPLETE_BUILDING:
      return <ChakraImage height="20px" src={MultipleBuildings} width="20px" />
    case AUTOCOMPLETE_ADDRESS:
    case AUTOCOMPLETE_POSTCODE:
    case AUTOCOMPLETE_NEIGHBORHOOD:
    case AUTOCOMPLETE_CITY:
    default:
      return <ChakraImage height="20px" src={ZipcodeIcon} width="20px" />
  }
}
